// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","grey":"#707070","wrapper":"_1AYG2ml6bPj3vCqEr6f2Ox","codeContainer":"_2LOkalbIMac22a1yJK1hC2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowCase/ShowCase.css
// module id = 857
// module chunks = 0